module.exports = __webpack_public_path__ + "static/img/17.bd84a3bd.jpg";